export const OTP_LENGTH = 6;
export const OTP_RESEND_SECONDS = 60;
export const PROFILE_POLL_ATTEMPTS = 5;
export const PROFILE_POLL_INTERVAL_MS = 1_000;
export const PASSWORD_MIN_LENGTH = 12;
